"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconCosmetics = function IconCosmetics(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M23.99 5.41a.52.52 0 0 0-.51.43A6.3 6.3 0 0 1 23 7.55c-.446.77-1.265.947-2.083 1.124-.246.053-.492.107-.727.176a9 9 0 0 0-2.9 1.35 9.3 9.3 0 0 0-2.606 2.8H12v4h-.5l-.09.008a.5.5 0 0 0 .09.992h.5v2h-1a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h26a3 3 0 0 0 3-3V23a3 3 0 0 0-3-3h-1v-2h.5l.09-.008A.5.5 0 0 0 36.5 17H36v-4h-2.493a12.44 12.44 0 0 0-5.927-6.63 10.5 10.5 0 0 0-3.52-1zm.41 1a9.7 9.7 0 0 1 2.73.85A11.28 11.28 0 0 1 32.41 13H15.88a8 8 0 0 1 2-2 7.9 7.9 0 0 1 2.56-1.2l.56-.11a3.74 3.74 0 0 0 2.85-1.64c.26-.516.439-1.07.53-1.64zM14 20v-2h4.5l.09-.008A.5.5 0 0 0 18.5 17H14v-2h20v2H22.5l-.09.008a.5.5 0 0 0 .09.992H34v2zm-4 3a1 1 0 0 1 1-1h26a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1zm26 15V27h-1v11zm0-14v2h-1v-2z",
    clipRule: "evenodd"
  })));
};

export { IconCosmetics, IconCosmetics as default };
